<script setup lang="ts">
definePage({
  meta: { auth: false },
});
</script>

<template>
  <div class="flex items-center justify-center py-48">
    <div class="flex flex-col items-center gap-30 text-center">
      <div class="lg:text-100 md:text-80 text-60 leading-none font-bold">404</div>
      <h1 class="lg:text-46 md:text-38 text-30 leading-tight font-bold">Page Not Found</h1>
      <p class="lg:text-18 md:text-16 text-14 max-w-500 px-30 lg:max-w-600">
        We're sorry, but the page you're looking for doesn't exist. It may have been moved or
        deleted, or you may have mistyped the address.
      </p>
      <router-link to="/" class="btn btn-green mt-20"> Return to Home </router-link>
    </div>
  </div>
</template>
